export const EMPLOYEE_HIERARCHY_MUTATION_X_API_KEY =
  'ff58a7bc-e1f0-4532-9caeY-474239543336';
